import React from "react";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import { useSelector } from "react-redux";

const Logo = ({ mini, mode, sx }) => {
  const { authUserLogo,authUserLogoHeight } = useSelector((state) => state.CommonReducer);
  let logoURL = "";
  const currentDomain = window.location.hostname;
  if (currentDomain.indexOf("adfuel.us") != -1) {
  } else {
    logoURL =
      mode === "light"
        ? ASSET_IMAGES + "/newlogo.png"
        : ASSET_IMAGES + "/newlogo_white.png";
  }

  //console.log("authUserLogo:", authUserLogo, mini);

  return (
    <Div sx={{ display: "inline-flex", ...sx }}>
      {authUserLogo != "" && (
        <Link href={"/dashboards/misc"}>
          {!mini ? (
            <img
              // src={
              //   mode === "light"
              //     ? authUserLogo != ""
              //       ? authUserLogo
              //       : logoURL
              //     : authUserLogo != ""
              //     ? authUserLogo
              //     : logoURL
              // }
              src={authUserLogo}
              alt="logo"
              height={authUserLogoHeight !=""?authUserLogoHeight+'px':'50px'}
              width="100%"
            />
          ) : (
            <img
              // src={
              //   mode === "light"
              //     ? authUserLogo != ""
              //       ? authUserLogo
              //       : `${ASSET_IMAGES}/logo-short.png`
              //     : authUserLogo != ""
              //     ? authUserLogo
              //     : `${ASSET_IMAGES}/logo-short-white.png`
              // }
              src={authUserLogo}
              alt="logo"
            />
          )}
        </Link>
      )}
    </Div>
  );
};

Logo.defaultProps = {
  mode: "light",
};

export default Logo;
